import React, { FC } from 'react';
import { FileMeta } from '../../../store/mediaAPI/document/dto/request/document-save-request';
import { Form } from 'react-bootstrap';

interface FileUploaderProps {
  setFile: (file: string) => void;
  setFileMeta?: (fileMeta: FileMeta) => void;
  fileSrc?: string;
}

const FileUploader: FC<FileUploaderProps> = ({
  setFile,
  setFileMeta,
  fileSrc,
}) => {
  const handleFileInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    const reader = new FileReader();

    reader.onload = () => {
      const dataUrl = reader.result;

      if (dataUrl) {
        setFile(dataUrl as string);
        setFileMeta &&
          setFileMeta({
            fileSrc: file?.name ?? '',
            fileType: file?.type,
          });
      }
    };

    file && reader.readAsArrayBuffer(file);
  };

  return (
    <>
      <Form>
        <Form.Group className="mb-3">
          <Form.Control
            type="file"
            onChange={handleFileInputChange}
            defaultValue={fileSrc}
          />
        </Form.Group>
      </Form>
    </>
  );
};

export default FileUploader;
